import React, { useEffect, useState } from 'react';
import PlatformStatistics from 'src/Components/AdminComponents/PlatformStatistics';
import SelectDropdown from 'src/Components/GlobalComponents/SelectDropdown';
import httpRequest from 'src/helpers/httpRequest';
import { toast } from 'react-toastify';
import { cityList } from 'src/Config/CityList';
import { IDropDownArray } from 'src/types/GlobalInterfaces';
import { CircularProgress } from '@mui/material';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { allMonths, allYears } from 'src/lib/constans';
import OverAllStatsGraph from 'src/Components/AdminComponents/Graphs/OverAllStatsGraph';

const timePeriodOptions: IDropDownArray[] = [{ label: "Monthly", value: "monthly" }, { label: "Yearly", value: "yearly" }];
const Dashboard: React.FC = () => {
    const [citySearch, setCitySearch] = useState<string>("");
    const [userStates, setUserStates] = useState<{
        loader: boolean;
        timePeriod: "monthly" | "yearly";
        totalUsers: number;
        customerYearlyData: { count: number; year: number; }[];
        customerMonthlyData: { count: number; month: number; year: number; }[];
        doctorYearlyData: { count: number; year: number; }[];
        doctorMonthlyData: { count: number; month: number; year: number; }[];
    }>({
        loader: false,
        timePeriod: "monthly",
        totalUsers: 0,
        customerYearlyData: [],
        customerMonthlyData: [],
        doctorMonthlyData: [],
        doctorYearlyData: [],
    });

    const formatedData = (): any => {
        const year = new Date().getFullYear();
        if (userStates?.timePeriod === "monthly") {
            const formattedData = allMonths.map(({ month, name }) => {
                const customerData = userStates?.customerMonthlyData?.filter(v => v?.year === year)?.find(v => v.month === month);
                const doctorData = userStates?.doctorMonthlyData?.filter(v => v?.year === year)?.find(v => v.month === month);
                return {
                    name: name,
                    customers: customerData ? customerData.count : 0, // Default to 0 if no data
                    doctors: doctorData ? doctorData.count : 0, // Default to 0 if no data
                };
            });
            return formattedData;
        } else {
            const formattedData = allYears.map(year => {
                const customerData = userStates?.customerYearlyData?.find(v => v.year === year);
                const doctorData = userStates?.doctorYearlyData?.find(v => v.year === year);
                return {
                    name: String(year), // year name
                    customers: customerData ? customerData.count : 0, // Default to 0 if no data
                    doctors: doctorData ? doctorData.count : 0, // Default to 0 if no data
                };
            });
            return formattedData;
        }
    };

    const fetchUsers = async () => {
        setUserStates(prev => ({ ...prev, loader: true }));
        const { res, err } = await httpRequest<{
            totalUsers: number;
            customerYearlyData: { count: number; year: number; }[];
            customerMonthlyData: { count: number; month: number; year: number; }[];
            doctorYearlyData: { count: number; year: number; }[];
            doctorMonthlyData: { count: number; month: number; year: number; }[];
        }>({ path: `/customer/registered-users-statistics?search=${citySearch}` });
        if (res) {
            setUserStates(prev => ({
                ...prev,
                totalUsers: res?.totalUsers || 0,
                customerYearlyData: res?.customerYearlyData || [],
                customerMonthlyData: res?.customerMonthlyData || [],
                doctorYearlyData: res?.doctorYearlyData || [],
                doctorMonthlyData: res?.doctorMonthlyData || [],
            }));
        } else {
            toast(err, { type: "error" });
        }
        setUserStates(prev => ({ ...prev, loader: false }));
    };

    useEffect(() => {
        fetchUsers();
    }, [citySearch]);
    return (
        <div className="gap-marging-admin container-bg-change">
            <PlatformStatistics />
            {/* GRAPHS AND CHARTS */}
            <div className="parent-box parent-box-graph-height">
                <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
                    <div>
                        <h2 className="font-Poppins-SemiBold text-[#232323] font-size-20px mb-2">Users</h2>
                        <div className='user-graph-inner'>
                            <div className='flex justify-between items-center mb-2 lg:mb-[0.7vw]'>
                                <div className='font-Poppins-Regular user-graph-header font-size-14px whitespace-nowrap w-auto'>
                                    Total Users: <span className='font-Poppins-SemiBold theme-color-green font-size-20px pl-1'>{userStates?.totalUsers || 0}</span>
                                </div>
                                <div className='flex gap-2'>
                                    <span className="flex items-center gap-1">
                                        <div className='bg-[#00a297] w-[8px] h-[8px] rounded-full'></div>
                                        <span className="font-Poppins-Regular font-size-16px">Customers</span>
                                    </span>
                                    <span className="flex items-center gap-1">
                                        <div className='bg-[#00443f] w-[8px] h-[8px] rounded-full'></div>
                                        <span className="font-Poppins-Regular font-size-16px">Doctors</span>
                                    </span>
                                </div>
                                <div className='select-container-graph-user-manag'>
                                    {/* <div className='select-container-graph select-dropdown-container-graps w-auto'>
                                        <SelectDropdown
                                            options={cityList}
                                            isMulti={false}
                                            data={cityList?.filter(v => v.value === citySearch)}
                                            setData={(e) => setCitySearch(e[0] ? e[0]?.value : "")}
                                            checkboxShow={false}
                                            isLabel={false}
                                        />
                                    </div> */}
                                    <div className='select-container-graph select-dropdown-container-graps w-auto'>
                                        <SelectDropdown
                                            options={timePeriodOptions}
                                            isMulti={false}
                                            data={timePeriodOptions?.filter(v => v.value === userStates?.timePeriod)}
                                            setData={(e) => setUserStates(prev => ({ ...prev, timePeriod: e[0] ? e[0]?.value : "" }))}
                                            checkboxShow={false}
                                            isLabel={false}
                                            isRequired={true}
                                            clearIcon={false}
                                        />
                                    </div>
                                </div>
                            </div>
                            {userStates?.loader &&
                                <div className="text-center">
                                    <CircularProgress size={20} style={{ color: "#004540" }} />
                                </div>
                            }
                            <ResponsiveContainer className={'user-graph-container'}>
                                <BarChart
                                    data={formatedData()}
                                    margin={{ top: 20, right: 0, left: -30, bottom: 0 }}
                                    barCategoryGap="15%"
                                >
                                    <CartesianGrid />
                                    <XAxis className='revenue-axis' dataKey="name" />
                                    <YAxis className='revenue-axis' />
                                    <Tooltip wrapperClassName='revenue-axis' />
                                    <Bar dataKey="customers" fill="#00A297" radius={[10, 10, 0, 0]} />
                                    <Bar dataKey="doctors" fill="#00443F" radius={[10, 10, 0, 0]} />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                    <OverAllStatsGraph
                        title="Sales"
                        type="BarChart"
                    />
                </div>
            </div>
        </div>
    );
};

export default Dashboard;